<template>
  <v-card tile :loading="loading">
    <v-dialog v-model="isAdding" width="750px">
      <v-card tile flat>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Add a new {{ service }} Entry</span>
          <v-btn text icon dark @click="isAdding = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <entry-form :service="service" @created="handleCreated" />
      </v-card>
    </v-dialog>

    <v-carousel
      :continuous="false"
      :cycle="false"
      height="700"
      hide-delimiter-background
      mandatory
      v-model="deafultTypeIndex"
    >
      <v-carousel-item v-for="item in types" :key="item.type">
        <v-toolbar color="grey lighten-4" light tile flat>
          <v-toolbar-title centered class="headline font-weight-bold">
            {{ item.title }}
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="isAdding = true">
            <v-icon>
              mdi-layers-plus
            </v-icon>
            Add Entry
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-simple-table height="580" light fixed-header class="table">
          <template v-slot:default>
            <thead>
              <tr>
                <th colspan="2"></th>
                <th class="text-center" colspan="2">Commission</th>
                <th class="text-center" colspan="2">Fees</th>
                <th></th>
              </tr>
              <tr>
                <th>Min</th>
                <th>Max</th>
                <th>Flat (Danacoin)</th>
                <th>Percentage</th>
                <th>Flat (Danacoin)</th>
                <th>Percentage</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <table-row
                v-for="item in entries"
                :key="item.id"
                :item="item"
                @deleted="handleDelete"
              />
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>
      </v-carousel-item>
    </v-carousel>
  </v-card>
</template>
<script>
import EntryForm from "./entryForm";
import TableRow from "./tableRow";
import { deleteArrayEntry } from "@/store/utils";
export default {
  components: { EntryForm, TableRow },
  data() {
    return {
      deafultTypeIndex: 0,
      types: [
        { type: "cashout", title: "Cashout Earning Structure" },
        { type: "transfers", title: "Transfer Earning Structure" },
      ],
      loading: false,
      entries: [],
      isAdding: false,
    };
  },
  created() {
    this.fetchStructure(this.deafultTypeIndex);
  },
  methods: {
    fetchStructure(index) {
      this.loading = true;
      this.entries = []; //clear entries
      this.$http
        .get("api/v1/transactions/earningStructure", {
          params: { service: this.getServiceName(index) },
        })
        .then((data) => {
          this.entries = data || [];
        })
        .catch(() => {
          window.Notify.warning("Something went wrong while fetching structure");
        })
        .finally(() => (this.loading = false));
    },
    getServiceName(index) {
      return this.objectValueFromPath(this.types, [index, "type"]);
    },
    handleCreated() {
      this.isAdding = false;

      this.fetchStructure(this.deafultTypeIndex);
      window.Notify.success("Entry was added successfully");
    },
    handleDelete(item) {
      this.entries = deleteArrayEntry(this.entries, item, "id");
      window.Notify.success("Entry was removed successfully");
    },
  },
  computed: {
    service() {
      return this.getServiceName(this.deafultTypeIndex);
    },
  },
  watch: {
    deafultTypeIndex(index) {
      this.fetchStructure(index);
    },
  },
};
</script>
<style scoped lang="scss">
table {
  th {
    border: 0.5px solid rgba(0, 0, 0, 0.12);
  }
  border-collapse: collapse;
}
</style>
